import React from "react";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/apps/reducers";
import { StoreSearchFilters } from "tsi-common-react/src/apps/retail/models";
import { updateStoreFilters } from "tsi-common-react/src/apps/retail/reducers";
import {
    filteredStoreSelector,
    storeSelector,
} from "tsi-common-react/src/apps/retail/selectors";

import { LocatorFilters as LocatorFiltersComponent } from "../components/LocatorFilters";

export const LocatorFilters = (): React.ReactNode => {
    const filterValues = useAppSelector((state) => state.retail.storeFilters);
    const currentLocation = useAppSelector(preferredLocationSelector);
    const allStores = useAppSelector(storeSelector);
    const filteredStores = useAppSelector(filteredStoreSelector);
    const dispatch = useAppDispatch();

    const onChange = (filters: Partial<StoreSearchFilters>) => {
        dispatch(updateStoreFilters(filters));
    };

    return (
        <LocatorFiltersComponent
            filterValues={filterValues}
            currentLocation={currentLocation}
            allStores={allStores}
            filteredStores={filteredStores}
            onChange={onChange}
        />
    );
};
